import { styled } from 'theme'

export const StyledAreaList = styled.div`
  background-color: white;
`
